import DynamicContent from "components/content/DynamicContent"
import fetchLocation from "utils/fetch-locations"
import fetchSocialMedia from "utils/fetch-social-media"
import BlogList from "../components/BlogList"
import Layout from "../components/Layout"
import { createApolloClient } from "../utils/apollo"
import { buildListQuery } from "../utils/blueprints/blog"
import fetchCompany from "../utils/fetch-company"
import fetchNav from "../utils/fetch-nav"
import fetchPage from "../utils/fetch-page"
import { replaceVariables } from "../utils/replaceVariables"
import PageHero from "components/PageHero"

function Wissen({ data, navs, company, content, locations, socialMediaLinks }) {
  return (
    <Layout
      navs={navs}
      company={company}
      content={content}
      locations={locations}
      socialMediaLinks={socialMediaLinks}
    >
      <PageHero data={content} style={{ marginBottom: 0 }} />
      <BlogList blogPosts={data} content={content} />
      <DynamicContent content={content} />
    </Layout>
  )
}

// Data for current page
// export const getServerSideProps = async (context) => {
export const getStaticProps = async (context) => {
  const { previewData } = context
  const apollo = createApolloClient(previewData?.token ?? null)

  const [res, navs, company, locations, socialMediaLinks, content] =
    await Promise.all([
      apollo.query({
        query: buildListQuery(),
      }),
      fetchNav(apollo, previewData?.unit),
      fetchCompany(apollo, previewData?.unit),
      fetchLocation(apollo, previewData?.unit),
      fetchSocialMedia(apollo, previewData?.unit),
      fetchPage({ apollo, slug: "wissen", isPreview: previewData?.unit }),
    ])

  if (content?.errors?.length) {
    throw new Error(content.errors[0]?.message)
  }

  if (res.errors?.length) {
    throw new Error(res.errors[0]?.message)
  }

  const data = (res.data.collection.structure.tree.map((d) => d?.entry) || [])
    .filter((e) => !!e && e.published)
    .reverse()

  if (!data.length || !content) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      data,
      navs,
      company,
      locations,
      socialMediaLinks,
      content: await replaceVariables(content),
    },
    // revalidate: 30,
  }
}

export default Wissen
